<div class="container my-5">
  <div class="card shadow">
    <div class="card-body">
      <mat-horizontal-stepper linear (selectionChange)="onStepChange($event)" #stepper>
        <!-- STEP 1: Inserisci nome, descrizione e allegati -->
        <mat-step [stepControl]="firstFormGroup" [editable]="false">
          <form [formGroup]="firstFormGroup" class="mt-4">
            <ng-template matStepLabel>{{ 'pages.ckm-simulations.enter_data' | translate }}</ng-template>
            <div class="form-group">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>{{ 'pages.ckm-simulations.name' | translate }}</mat-label>
                <input matInput placeholder="{{ 'pages.ckm-simulations.name' | translate }}" formControlName="name" required>
                <mat-error *ngIf="firstFormGroup.get('name')?.hasError('required')">
                  {{ 'pages.ckm-simulations.name_required' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group mt-3">
              <app-rich-text-editor
                formControlName="description"
                [placeholder]="'pages.ckm-simulations.enter_description' | translate"
                [isPreview]="false">
              </app-rich-text-editor>
            </div>

            <!-- Sezione per la gestione degli allegati -->
            <div class="form-group mt-5">
              <app-attachment-manager
                [attachments]="attachments"
                [allowedAttachmentTypes]="['FILE', 'PUBMED']"
                [uploadUrl]="'upload/tmp-proposal-file'"
                (attachmentsChange)="onAttachmentsChange($event)">
              </app-attachment-manager>
            </div>

            <div class="d-flex justify-content-end mt-4">
              <button mat-raised-button color="primary" matStepperNext [disabled]="firstFormGroup.invalid">
                {{ 'pages.ckm-simulations.next' | translate }}
              </button>
            </div>
          </form>
        </mat-step>

        <!-- STEP 2: Generazione AI (non è possibile tornare indietro) -->
        <mat-step [editable]="false">
          <ng-template matStepLabel>{{ 'pages.ckm-simulations.ai_generation' | translate }}</ng-template>
          <div *ngIf="!generationComplete" class="text-center my-4">
            <mat-progress-spinner
              mode="indeterminate"
              [diameter]="40"
              [strokeWidth]="4"
              class="d-block mx-auto">
            </mat-progress-spinner>
            <p class="mt-3">{{ 'pages.ckm-simulations.generating' | translate }}</p>
          </div>
          <div *ngIf="generationComplete" class="text-center my-4">
            <p>{{ 'pages.ckm-simulations.generation_complete' | translate }}</p>
            <button mat-raised-button color="primary" matStepperNext>
              {{ 'pages.ckm-simulations.next' | translate }}
            </button>
          </div>
        </mat-step>

        <!-- STEP 3: Completato -->
        <mat-step>
          <ng-template matStepLabel>{{ 'pages.ckm-simulations.done' | translate }}</ng-template>
          <div class="text-center my-4">
            <p>{{ 'pages.ckm-simulations.all_ready' | translate }}</p>
            <button mat-raised-button color="primary" (click)="navigateToPage()">
              {{ 'pages.ckm-simulations.go_to_page' | translate }}
            </button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>
</div>
